import React from 'react';
import VolArb from '../components/VolArb/VolArb';

function VolArbView() {
  return (
    <div className="vol-arb-view">
      <VolArb />
    </div>
  );
}

export default VolArbView;
